import type * as WmeaModule from "@nuralogix.ai/web-measurement-embedded-app";

export async function loadWmea(): Promise<typeof WmeaModule> {
  const url = `${process.env.PUBLIC_URL || ""}/wmea/1.2.0/lib/index.mjs`;
  return import(/* webpackIgnore: true */ url);
}
